import { RefreshCw, Wrench } from "lucide-react";

import { Button } from "../ui/button";
import { MarcaDoSistema } from "./MarcaDoSistema";

/**
 * "Sistema em atualização — voltamos em instantes."
 *
 * Tela inteira, sem nada do app por trás: aparece quando o banco ainda não tem
 * as migrations que este build espera (ou a API está recarregando o esquema).
 * Texto injetado pelo app, como na 404.
 */
export interface SistemaEmAtualizacaoTextos {
  /** "Sistema em atualização" */
  titulo: string;
  /** "Estamos publicando uma nova versão. Voltamos em instantes." */
  descricao: string;
  /** "Nova tentativa em {s} s" */
  proximaTentativa: (segundos: number) => string;
  /** "Verificando…" */
  verificando: string;
  /** "Tentar agora" */
  tentarAgora: string;
}

export interface SistemaEmAtualizacaoProps {
  textos: SistemaEmAtualizacaoTextos;
  segundosParaNovaTentativa: number;
  verificando: boolean;
  onTentarAgora: () => void;
  /** Rodapé discreto, ex.: "v2026.1011.71 · abc1234" (ajuda o suporte). */
  rodape?: string;
}

export function SistemaEmAtualizacao({
  textos,
  segundosParaNovaTentativa,
  verificando,
  onTentarAgora,
  rodape,
}: SistemaEmAtualizacaoProps) {
  return (
    <main
      data-pps-component="sistema-em-atualizacao"
      className="flex min-h-screen w-full items-center justify-center bg-background px-4 py-10"
    >
      <div className="w-full max-w-md text-center">
        <MarcaDoSistema />
        <div className="mx-auto mt-8 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Wrench className="h-8 w-8" aria-hidden="true" />
        </div>
        <h1 className="mt-6 text-2xl font-bold text-foreground sm:text-3xl">{textos.titulo}</h1>
        <p className="mt-3 text-base text-muted-foreground">{textos.descricao}</p>
        <p className="mt-6 text-sm text-muted-foreground" role="status" aria-live="polite">
          {verificando ? textos.verificando : textos.proximaTentativa(segundosParaNovaTentativa)}
        </p>
        <div className="mt-4 flex justify-center">
          <Button
            type="button"
            size="lg"
            className="w-full sm:w-auto"
            onClick={onTentarAgora}
            disabled={verificando}
          >
            <RefreshCw
              className={verificando ? "mr-2 h-4 w-4 animate-spin" : "mr-2 h-4 w-4"}
              aria-hidden="true"
            />
            {textos.tentarAgora}
          </Button>
        </div>
        {rodape ? <p className="mt-10 font-mono text-xs text-muted-foreground/70">{rodape}</p> : null}
      </div>
    </main>
  );
}
